import React from 'react'

import type { FormWizardV2ContextType } from './types'

export const FormWizardV2Context = React.createContext<FormWizardV2ContextType<string>>(
  null as never
)

export function useFormWizardV2Context<T extends string>(): FormWizardV2ContextType<T> {
  return React.useContext(FormWizardV2Context)
}
